import Lista from './Lista';
import UploadLista from './UploadLista';

export const HoleriteLista = Lista;
export const HoleriteUploadLista = UploadLista;
